import React from 'react';
//import Link from '../../../components/Link';
import MainContainer from '../../Main';
import BidPersonHistory from '../../../components/PersonProfile/BidPersonHistory';
import SidebarAuctions from '../../../components/PersonProfile/SidebarAuctions';
import { /*FormattedMessage,*/ injectIntl } from 'react-intl';
import page from 'page'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, /*withHandlers, withState,*/ lifecycle } from 'recompose'
import { logOut } from '../../../store/reducers/auth'
import { fetchingState } from './../../../helpers/hocs.js'
import { getIsLogged, /*getLoggedUser*/ } from '../../../selectors/user.js'
//import { getState, paidIsDone, requestMeet } from '../../../store/reducers/profile/info'
import { get, getLots, getActiveLot, /*subsribe*/ } from '../../../store/reducers/persons/info';
import { getTotalLotsSum, getFunds } from '../../../selectors/person';
import ProfileWrapper from '../../../components/PersonProfile/ProfileWrapper';
import moment from 'moment';
import Select from '../../../components/Select';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { getLotsList } from '../../../selectors/lots';
import { sendFirstLotView } from '../../../store/reducers/role';

//компонент аукционов для роли персоны
const Auctions = ({ lots, active, total, funds, user, logOut, isLogged, currentData, setCurrentData, tab, setTab, watchLots }) => {
  if (!user && !user.person && !isLogged) return null

  const activeLots = [];
  const completedLots = [];
  const forApprovalLots = [];

  if (Object.keys(lots).length > 0) {
    Object.keys(lots).forEach(lot => {
      switch (lots[lot].status) {
        case "complete":
          completedLots.push(lots[lot]);
          break;
        case "active":
          activeLots.push(lots[lot]);
          break;
        case "inactive":
          forApprovalLots.push(lots[lot]);
          break;
        case "declined":
          completedLots.push(lots[lot]);
          break;
      }
    })
  }

  const getNextTab = (data, type) => {
    setTab(true)
    setCurrentData({ data: data, type: type })
    watchLots({lotId: data._id});
  }

  const back = () => {
    setTab(false)
  }
  // console.log(Object.keys(lots))

  return (
    <ProfileWrapper
      title={`${total.sum} ₽`}
      text="собрано на благотворительных аукционах с вашим участием"
      active="auctions"
      switch={{ status: tab, currentData: currentData }}
      back={back}
    >
      {/* <MainContainer
          Sidebar={<SidebarAuctions funds={funds || {}} totalSum={total} />}
        > */}
      {/* <div className='_auction-history history-title'>История участия</div> */}
      {/* <div className='person _auctions-history items'> */}
      {/* {(lots) && (<BidPersonHistory show={true} items={lots} />)} */}
      {forApprovalLots.length > 0 && <Select
        required
        items={forApprovalLots.map(lot => ({
          name: "Карточка лота",
          sub: "ожидает согласования",
          onClick: () => getNextTab(lot, "lotCard")
        }))}
        class="Select_theme_block"
        placeholder="Материалы на согласование"
        sub={forApprovalLots.length}
      />}

      {activeLots.length > 0 && <Select
        required
        items={activeLots.map(lot => ({
          name: moment(lot.startDate).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY'),
          sub: `завершится ${moment(lot.closeDate).fromNow()}`,
          onClick: () => getNextTab(lot, "auction")
        }))}
        class="Select_theme_block"
        placeholder="Активные аукционы"
        sub={activeLots.length}
      />}


      {completedLots.length > 0 && <Select
        required
        items={completedLots.map(lot => ({
          name: moment(lot.startDate).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY'),
          sub: `дата завершения: ${moment(lot.closeDate).utc().add(3, 'hours').format('DD/MM/YYYY')}`,
          onClick: () => getNextTab(lot, "expired-auction")
        }))}
        class="Select_theme_block"
        placeholder="Завершенные аукционы"
        sub={completedLots.length}
      />}
      {/* {
               completedLots.length === 0 && activeLots.length === 0  && forApprovalLots.length === 0 && 
               <p style={{paddingLeft: "16px", color: "#8c8c8c"}}>
                   У вас пока не было благотворительных встреч
               </p>
            } */}


      {/* </div> */}
      {/* </MainContainer> */}
    </ProfileWrapper>
  )
}

const mapStateToProps = state => ({
  isLogged: getIsLogged(state),
  total: getTotalLotsSum(state),
  funds: getFunds(state),
  //lots: getLots(state),
  lots: { ...state.lots.list.items },
  ...state.persons.info,
})

const mapDispatchToProps = dispatch => bindActionCreators({ get, getLots, getActiveLot, logOut, sendFirstLotView }, dispatch)
const mergeProps = (state, { get, getLots, getActiveLot, logOut, sendFirstLotView, ...dispatch }, props) => ({
  ...props,
  ...state,
  logOut,
  get: async (id) => {
    let memberId = id || props.user.person._id;
    let result = await props.fetchingWrap(get.bind(this, memberId), 'info')
    if (result === 200) {
      props.fetchingWrap(getLots.bind(this, memberId), 'lots')
      props.fetchingWrap(getActiveLot.bind(this, memberId), 'active')
      // await getLots()
    } else props.on404()
  },
  sendLotView: (lotId) => {
    return (props.fetchingWrap(sendFirstLotView.bind(this, lotId), 'send'))
  }
})

export default injectIntl(compose(
  withState("currentData", "setCurrentData", {}),
  withState("tab", "setTab", false),
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    watchLots: ({ sendLotView }) => async (lot, e) => {
      const result = await sendLotView(lot.lotId);
    }
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.setCurrentData(null)
    },
    componentWillMount() {
      if (!this.props.isLogged) this.props.on404()
      else {
        this.props.get()
      }
    },
    componentWillReceiveProps(np) {
      if (this.props.isLogged && !np.isLogged) page('/')
      if ((np.user && np.user.person) && (np.user.person._id !== this.props.user.person._id)) {
        this.props.get(np.user.person._id)
      }
    }
  })
)(Auctions))


// WEBPACK FOOTER //
// ./src/containers/roles/person/Auctions.jsx